// extracted by mini-css-extract-plugin
export var container = "_q1-0";
export var dotAnimation = "_q1-2";
export var dotsLoading = "_q1-1";